import React, { useState, useEffect } from 'react';
import './totalfee.css';
import api from '../../service/caller';
import { format } from 'date-fns';
import { ToastContainer, toast } from 'react-toastify';
import Modal from 'react-modal';
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';



Modal.setAppElement('#root');

function CalculFrais({ onNext, onBack, patientData }) {
    const [traitmentdata, setTraitmentData] = useState(null);
    const [billing, setBilling] = useState(null);
    const [dischargedata, setDischargedata] = useState(null);
    const [dischargeExists, setDischargeExists] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);

    useEffect(() => {
        const fetchTraitmentData = async () => {
            try {
                const response = await api.get(`api/rooms/hospitalization/totalfee/${patientData._id}`);
                setTraitmentData(response.data);
            } catch (error) {
                toast.error("Erreur chargement données hospitalisation");
            }
        };

        const checkDischargeExistence = async () => {
            try {
                const response = await api.get(`/api/discharge/${patientData._id}`);
                setDischargeExists(true);
                setDischargedata(response.data.data);
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    setDischargeExists(false);
                } else {
                    toast.error("Erreur lors de la vérification de la décharge");
                }
            }
        };
        const fetchBillingData = async () => {
            if (!dischargedata?._id) return; 
            try {
                const response = await api.get(`/clinic/billing/checkExistingBilling/${dischargedata._id}`);
                setBilling(response.data.billing);
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    toast.error("Erreur lors de la vérification de la facturation");
                }
            }
        };

        fetchTraitmentData();
        checkDischargeExistence();
        if (dischargedata?._id) {
            fetchBillingData();
        }
    
    }, [patientData,dischargedata]);

    // recuperer le billing en fonction de l'id de la decharge


    if (!traitmentdata) return <div>Chargement des données...</div>;

    const { admission, room, grandTotal, treatmentPlan } = traitmentdata;

    const formatDate = (dateString) => new Date(dateString).toLocaleDateString();
    const currency = admission.hospitalId?.hospital_currency || '';

    const printPDF = async () => {
        const element = document.querySelector('.parttoimprime');
        if (!element) return;

        try {
            const canvas = await html2canvas(element, {
                scale: 2,
                useCORS: true,
                backgroundColor: '#ffffff'
            });

            const imgData = canvas.toDataURL('image/jpeg', 1.0);
            const pdf = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: 'a4'
            });

            const imgWidth = 210; // A4 width
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight);
            pdf.save(`${admission.patientId.lastname} ${admission.patientId.firstname}_facture.pdf`);
        } catch (error) {
            console.error('Erreur de génération PDF:', error);
        }
    };

    return (
        <>
            <ToastContainer />
            <div className="bill-container">
                <div className="bill-printable-section">
                    <h1 className="bill-header">Calcul des frais</h1>

                    <div className="bill-content">
                    <div className="bill-details">
                        <h6 className="bill-section-title"><strong>Détails</strong></h6>
                        <p className="bill-detail-item"><strong>Nom Patient :</strong> {admission.patientId.lastname} {admission.patientId.firstname}</p>
                        <p className="bill-detail-item"><strong>Chambre :</strong> {room.roomNumber}</p>
                        <p className="bill-detail-item"><strong>Lits :</strong> {admission.bedNumber}</p>
                        <p className="bill-detail-item"><strong>Début :</strong> {formatDate(admission.admissionDate)}</p>
                        {dischargeExists && billing && billing.paymentstatus === false && (
                        <p className="bill-payment-code">
                            Veuillez presenter ce code lors du paiement a la caisse : 
                            <strong className="bill-payment-id"> {billing.paymentuniqueId}</strong>
                        </p>
                        )}
                    </div>

                    <div className="bill-table-container">
                        <table className="bill-table">
                        <thead>
                            <tr>
                            <th className="bill-table-header">Type</th>
                            <th className="bill-table-header">Détails</th>
                            <th className="bill-table-header">Prix unitaire</th>
                            <th className="bill-table-header">Quantité</th>
                            <th className="bill-table-header">Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {treatmentPlan.medications?.map((med, i) => (
                            <tr key={`med-${i}`} className="bill-table-row">
                                {i === 0 && (
                                <td rowSpan={treatmentPlan.medications.length} className="bill-table-cell bill-type-cell">Médicament</td>
                                )}
                                <td className="bill-table-cell">{med.name}</td>
                                <td className="bill-table-cell">{med.price} {currency}</td>
                                <td className="bill-table-cell">1</td>
                                <td className="bill-table-cell">{med.price}</td>
                            </tr>
                            ))}

                            {treatmentPlan.procedures?.map((proc, i) => (
                            <tr key={`proc-${i}`} className="bill-table-row">
                                {i === 0 && (
                                <td rowSpan={treatmentPlan.procedures.length} className="bill-table-cell bill-type-cell">Procedure</td>
                                )}
                                <td className="bill-table-cell">{proc.name}</td>
                                <td className="bill-table-cell">{proc.price} {currency}</td>
                                <td className="bill-table-cell">1</td>
                                <td className="bill-table-cell">{proc.price}</td>
                            </tr>
                            ))}

                            <tr className="bill-table-row">
                            <td className="bill-table-cell bill-type-cell">Hospitalisation</td>
                            <td className="bill-table-cell">Durée: {room.stayDays} jours</td>
                            <td className="bill-table-cell">{room.pricePerDay} {currency}</td>
                            <td className="bill-table-cell">{room.stayDays}</td>
                            <td className="bill-table-cell">{room.stayDays * room.pricePerDay}</td>
                            </tr>
                        </tbody>
                        </table>
                    </div>

                    <p className="bill-total"><strong>Montant final : {grandTotal} {currency}</strong></p>
                    </div>
                </div>

                <div className="bill-actions">
                    {!dischargeExists && (
                    <button className="bill-button bill-button-primary" onClick={() => onNext(7)}>
                        Faire la Décharge
                    </button>
                    )}
                    {dischargeExists && (
                    <button className="bill-button bill-button-print" onClick={printPDF}>
                        Imprimer en PDF
                    </button>
                    )}
                    {onNext && (
                    <button className="bill-button bill-button-back" onClick={() => onNext(1)}>
                        Retour
                    </button>
                    )}
                </div>
            </div>
        </>
    );
}

export default CalculFrais;
